<template>
  <table-layout title="محصولات">
    <template #buttons>
      <b-row>


        <router-link :to="{ name: 'ProductsDashboard' }" class="ml-2 mt-1">
          <b-button pill variant="purple">محصولات</b-button>
        </router-link>

        <LanguageSelectBox @changeLanguage="getWishListProducts" module-name="wishList" class="mx-4"/>

      </b-row>

    </template>

    <template #table>
      <table-items :items="wishListItems" :restoreState="false"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changeProductsPage"/>
      </b-row>
    </template>


  </table-layout>
</template>

<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout.vue";
import tableItems from "../../components/dashboard/product/tableItems.vue";
import Pagination from "../../components/dashboard/Pagination.vue";
import Filters from "../../components/dashboard/product/Filters";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";

export default {
  name: "WishList",
  components: {TableLayout, tableItems, Pagination, Filters, LanguageSelectBox},
  data() {
    return {
      wishListItems: [],
      paginationMeta: {}
    }
  },
  computed: {
    ...mapGetters({
      userId: 'User/getUserId'
    }),
  },
  methods: {
    changeProductsPage(page) {
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...{page: page}}})
      this.getWishListProducts(page)
    },
    async getWishListProducts(page = 1) {

      let form = {
        page: page,
        user_id: this.userId
      }

      let item = await this.$store.dispatch('WishList/loadUserWishList', form)
      let baseData = item.data.data
      let productsData = baseData.data.map(item => item.itemable)

      this.paginationMeta = baseData.meta
      this.wishListItems = productsData

    }
  },
  async mounted() {
    await this.getWishListProducts();
  },
};
</script>